import React, {useEffect, useState} from 'react';
import {useAuth} from "../../providers/authprovider";
import {Button, Col, Form, FormControl, InputGroup, Pagination, Row, Table} from "react-bootstrap";
import AddEditClientForm from "./AddEditClientForm";
import {ControlledMenu, MenuItem, useMenuState} from "@szhsin/react-menu";
import {
    useNavigate
} from "react-router-dom";
import ResponseAlert from "../../components/ResponseAlert";
import {useMemo} from "react";
import Client from "./Client";


export default function Clients(props)  {

    const {privilege} = props;


    const auth = useAuth();
    const [clients, setClients] = useState(undefined);
    const [addEditClient, setAddEditClient] = useState({
        show:false,
        client: undefined,
    });
    const [alert, setAlert] = useState({show:false, error: ""})


    useEffect(()=>{
        if(clients !== undefined)
            return;

        auth.clients.get(({success, error, content})=>{
            if(success)
                return setClients(content);

            setAlert({show: true, error: error})
            setClients([])
        })
    });

    const showModal = ()=>{
        setAddEditClient({
            show:true,
            client:undefined
        })
    }

    const handleHideClientForm = (response)=>{

        if(response === undefined)
            return setAddEditClient({
                show:false,
                client:undefined
            });

        const {success, error, content} = response;


        if(success){
                const client = content;

                const existingIndex = clients.findIndex(c=>c.id === client.id)
                if(existingIndex > -1)
                    clients.splice(existingIndex, 1, client)
                else
                    clients.push(client)


            setClients(clients);
            setAddEditClient({
                show:false,
                client:undefined
            })
            return;
        }

        setAlert({show:true, error: error})
    }

    const handleEditClient = (clientId)=>{
        const client = clients.find(c=>c.id === clientId);
        setAddEditClient({
            show:true,
            client:client
        })
    }


    const buttonAddClient = privilege.edit === true ? <Button className="me-4 float-end"   onClick={showModal} >Dodaj</Button> : null;

    if(clients === undefined)
        return ;

    return (

        <>
            {
                addEditClient.show ?
                    <AddEditClientForm client={addEditClient.client} onHide={handleHideClientForm}  />
                    :
                    <>
                        <ResponseAlert show={alert.show} error={alert.error} code={alert.code} />

                        <TableClients privilege={privilege} onEditClient={handleEditClient}  clients={clients.map(Client)} btnAddClient={buttonAddClient} />
                        {/*{buttonAddClient}*/}
                    </>

            }


        </>
    );
}
function TableClients(props) {
    const columns = [
        {name:"Nazwa", key:'name'},
        {name:"Adres", key:'address'},
        {name:"NIP", key:'nip'},
        {name:"Spółka", key:'rajcompany'},
        {name:"Opis", key:'description'},
        {name:"Osoby", key:'persons'},
        {name:"Budynki", key:'buildings_link'},
    ]
    const {privilege, btnAddClient} = props;
    const navigate = useNavigate();

    const clientsDataSet = props.clients;
    const [clients, setClients] = useState(props.clients);
    const {user, clients : {deleteClient}} = useAuth();
    const [searchTimingHook, setSearchTimingHook] = useState(undefined);
    const [menuProps, toggleMenu] = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
    const [currentContextClient, setCurrentContextClient] = useState(undefined)
    const [currentPage, setCurrentPage] = useState(0);
    const pages = useMemo(()=>{
        let items = [];
        if(clients === undefined || clients.length<=0)
            return items;

        items.push(<Pagination.Prev key={-1} onClick={()=>setCurrentPage(Math.max(currentPage-1, 0))} />)

        const pagesNum = Math.ceil(clients.length / 50);


        for(let i=0; i< pagesNum; i++){

            items.push(
                <Pagination.Item key={i} active={i === currentPage} onClick={()=>setCurrentPage(i)}>
                    {i+1}
                </Pagination.Item>
            );
        }

        // <Pagination.Ellipsis />

        items.push(<Pagination.Next key={pagesNum} onClick={()=>setCurrentPage(Math.min(currentPage+1, pagesNum-1))} />)

        return items;
    }, [currentPage,clients]);
    const [sortBy, setSortBy] = useState({key:null, order:1}); //order 1 mean ascending,-1 descending


    const handleClientContextMenu = (e, client) => {
        e.preventDefault();
        setAnchorPoint({ x: e.clientX, y: e.clientY });
        toggleMenu(true);
        setCurrentContextClient(client)
    }

    const setSorting = (key)=>{
        setSortBy((prevState)=>{
            const newState = {key:key, order:1};
            if(prevState.key === key)
                newState.order = prevState.order === 1 ? -1:1;

            const sorted = clients.sort((clientA, clientB)=>{
                if(clientA[key] === undefined || clientA[key] === null)
                    return newState.order;

                let valA  = Number(clientA[key]);
                let valB  = Number(clientB[key]);

                if(isNaN(valA))
                    return clientA[key]?.localeCompare(clientB[key]) * newState.order
                else
                    return (valA - valB) * newState.order;
            })
            setClients([...sorted]);
            return newState;
        })
    }

    const handleEditClient = ()=>{
        if(props.onEditClient && currentContextClient)
            props.onEditClient(currentContextClient.id);
    }

    const handleSearch = (event)=>{
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;
        const query = form.elements['searchField'].value

        filterByQuery(query)
    }

    const handleTypingSearch = (e)=>{
        window.clearTimeout(searchTimingHook);

        const hook = setTimeout(
            function(){
                filterByQuery(e.target.value);
            }, 400
        )

        setSearchTimingHook(hook)
    }

    function filterByQuery(query){
        window.clearTimeout(searchTimingHook);

        const result = clientsDataSet.filter(client=>{
            return client.search(query)
        });
        setCurrentPage(0);
        setClients(result);
    }

    const handleDeleteClient = ()=>{
        if(!currentContextClient) return;

        const reason = window.prompt("Proszę wprowadzić powód usunięcia klienta: "+currentContextClient.name);

        if(reason.length <= 0)
            return alert("Proszę podać powód usunięcią klienta.")


        deleteClient(currentContextClient.id, reason, ({success, error, content})=>{
            if(!success)
                return window.alert(error)

            setClients(clients.filter(c=>c.id !== currentContextClient.id))
            window.alert("Klient został usunięty.")
        })
    }

    const menuItemDelete = user.isAdmin ? <MenuItem onClick={() => {handleDeleteClient()}}>Usuń klienta</MenuItem> : ""

    return (
        <div className={"p-2"}>

            {
                privilege.edit &&
                <ControlledMenu {...menuProps} anchorPoint={anchorPoint}
                                onClose={() => toggleMenu(false)}>
                    <MenuItem onClick={() => {
                        handleEditClient();
                    }}>Edytuj</MenuItem>
                    <MenuItem onClick={() => {
                        navigate("/buildings/create?clientId=" + currentContextClient.id);
                    }}>Dodaj budynek</MenuItem>
                    {menuItemDelete}
                </ControlledMenu>
            }
            <Row>
               <Col >
                   <Form  onSubmit={handleSearch}>
                       <InputGroup className="mb-3 w-50">
                           <FormControl
                               placeholder="wpisz szukaną frazę"
                               aria-label="search placeholder"
                               aria-describedby="seach_field"
                               name={"searchField"}
                               onChange={handleTypingSearch}
                           />
                           <Button type={"submit"} variant="outline-secondary" id="button-addon2">
                               Szukaj
                           </Button>
                       </InputGroup>
                   </Form>
               </Col>
               <Col>
                   {btnAddClient}
               </Col>
            </Row>


            <Table size={"sm"} striped bordered  className={"clientsTable"}>
                <thead>
                <tr>
                    <th key={-1}>#</th>
                    {
                        columns.map((col, i)=> {
                            // ' 🔽'
                            //                         : ' 🔼'
                            const sortedBy = sortBy.key === col.key ? "sorted_"+sortBy.order :"";
                            return <th key={i} onClick={() => setSorting(col.key)}
                                       className={sortedBy}><span>{col.name}</span></th>
                        } )
                    }
                </tr>
                </thead>
                <tbody>
                {
                    clients && clients.map((client,lp)=>{
                        const startPos = currentPage*50;
                        const endPos = startPos+50;

                        if(lp < startPos || lp >= endPos)
                            return null;
                        return (
                            <tr key={client.id} onContextMenu={(e)=>handleClientContextMenu(e,client)}>
                                <td>{lp+1}</td>
                                {
                                    columns.map(col=>
                                        <td key={col.key}>{client[col.key]}</td>
                                    )
                                }
                            </tr>
                        )
                    })
                }
                </tbody>
            </Table>
            <Pagination style={{justifyContent: 'center'}}>
                { pages }
            </Pagination>
        </div>
    )
}


